// store/modules/ArticleVuex.ts
import { Module, VuexModule, Mutation, Action } from 'vuex-module-decorators';
import TagHistoryService from '@/Services/TagHistoryService';
import {TagHistory} from '@/models/TagHistory';
import TagService from '@/Services/TagService';
@Module({ namespaced: true })
export default class TagModule extends VuexModule {
    tags: TagHistory[] = [];
    error: string | null = null;
    tag: TagHistory | null = null;

    @Mutation
    setTags(Tags: TagHistory[]) {
        this.tags = Tags;
    }
    @Mutation
    setTag(Tag: TagHistory) {
        this.tag =Tag;
    }

    @Mutation
    setError(error: string | null) {
        this.error = error;
    }

    @Action
    async fetchTags({ id, url }: { id: number, url: string }) {
        try {
            const response = await TagHistoryService.getAll({ id, url });
            
            // Détecter si c'est un export
            const isExport = url.includes('export=excel') || url.includes('export=csv');
            
            if (isExport) {
                return response;
            }
            
            // Pour les données normales
            if (response.data) {
                this.context.commit('setTags', response.data);
            }
            
            return response; // Return full response for DataTable
        } catch (error:any) {
            this.context.commit('setError', error.message || 'An error occurred while fetching tags.');
            throw error;
        }
    }

    get getAll() {
        return this.tags;
    }
    get getTag() {
        return this.tag;
    }

}
